export default {"src":"/_next/static/media/businessAvoidHeadlines.849889f3.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};